/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style utility container so all local storage related
 * stuff has a centralized wrapper.
 */
var iaw = iaw || { };

iaw.localstorage = {
	userID: null,

	/**
	 * Set a value to the local storage for a specified userID.
	 *
	 * @param userID            user's associated ID value
	 * @param key               local store key
	 * @param val               value to store
	 */
	setUserItem: function( key, val ) {
		if ( this.userID && key ) {
			// @ifdef DEBUG
			// iaw.log.console('[iaw.localstorage.setUserItem] Setting '+key+' to '+val);
			// @endif
			window.localStorage[this.userID+'_'+key] = JSON.stringify(val);
		}
	},

	/**
	 * Get a value from local storage for a specified userID.
	 * If the value is not found, a null object is returned.
	 *
	 * @param userID            user's associated ID value
	 * @param key               local store key
	 * @return The stored value or null if not present.
	 */
	getUserItem: function( key ) {
		var val = null;

		if ( this.userID && key ) {
			val = window.localStorage[this.userID+'_'+key] || null;
		}

		try {
			val = JSON.parse(val);
		}
		catch (err) {
			val = null;
		}

		return val;
	},

	/**
	 * Set a value to the local storage.
	 *
	 * @param key               local store key
	 * @param val               value to store
	 */
	setGlobalItem: function( key, val ) {
		if ( key ) {
			window.localStorage[key] = JSON.stringify(val);
		}
	},

	/**
	 * Get a value from local storage.
	 * If the value is not found, a null object is returned.
	 *
	 * @param key               local store key
	 * @return The stored value or null if not present.
	 */
	getGlobalItem: function( key ) {
		var val = null;

		if ( key ) {
			val = window.localStorage[key] || null;
		}

		try {
			val = JSON.parse(val);
		}
		catch (err) {
			val = null;
		}
		
		return val;
	}
};
